import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { Breadcrumb } from '@/features/breadcrumb/breadcrumb';
import { Route } from '@/routes';

export const ProjectListWrapper: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Breadcrumb label={t('navbar.breadcrumbs.home')} to={`/${Route.PROJECTS}`} />
      <Outlet />
    </>
  );
};
